<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("template.text1") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                <v-layout row wrap>
                  <v-flex xs10 lg3 ml-4
                    ><v-btn color="#077893" outlined to="/email-template-add">
                      <v-icon class="mr-1">mdi-plus</v-icon
                      >{{ $t("template.text2") }}
                    </v-btn>
                    <br />
                    <br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 lg4 mr-4>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-n4">
                <v-card outlined>
                  <v-data-table
                    :headers="headers"
                    :items="ItemPolicy"
                    :search="Search"
                    hide-default-footer
                    :page.sync="Page"
                    @page-count="PageCount = $event"
                    :items-per-page="ItemPerPage"
                  >
                    <template v-slot:[`item.UpdatdeBy`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeBy }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeByEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeAt }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>
                        <div v-for="(list, i) in itemsAction" :key="i">
                          <v-list
                            dense
                            v-if="
                              list.service === 'Preview' ||
                              item.TemplateId != 'EMAIL-0000-0001'
                            "
                          >
                            <v-list-item
                              @click="fn_checkActionType(list.service, item)"
                              link
                            >
                              <v-list-item-icon class="mr-3">
                                <v-icon :color="list.color"
                                  >{{ list.icon }}
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-title
                                v-if="$t('default') === 'th'"
                                :inner-text.prop="list.text"
                                style="font-size: 14px"
                              ></v-list-item-title>
                              <v-list-item-title
                                v-else
                                :inner-text.prop="list.text2"
                                style="font-size: 14px"
                              ></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </div>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-card>

                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogDelete
        :show="DialogDelete"
        :_item="ItemDelete"
        @closeDialogDelete="DialogDelete = false"
        @reData="Fn_GetDataTemplateEmail()"
      />
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import DialogDelete from "@/components/dialog/DialogTemplateEmailDelete.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogDelete, OverlaySearch },
  data: function () {
    return {
      Search: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ItemPolicy: [],
      ItemDelete: [],
      DialogDelete: false,
      loadingDownloadData: false,
      itemsAction: [
        {
          icon: "mdi-pencil",
          text: "แก้ไขข้อมูล",
          text2: "Edit",
          color: "orange",
          service: "Edit",
        },
        {
          icon: "mdi-trash-can",
          text: "ลบข้อมูล",
          text2: "Delete",
          color: "red",
          service: "Del",
        },
        {
          icon: "mdi-text-box-search",
          text: "ดูรายละเอียด",
          text2: "Preview",
          color: "success",
          service: "Preview",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },

    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          value: "no",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("template.text4"),
          align: "center",
          value: "NameTemplate",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.cby"),
          value: "UpdatdeBy",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.led"),
          value: "UpdatdeAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.select"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  companyth: {
    get() {
      if (this.$i18n.locale === "th") {
        return this.profile.name_on_document_th;
      } else {
        return this.profile.name_on_document_eng;
      }
    },
  },
  mounted() {
    this.Fn_GetDataTemplateEmail();
  },
  methods: {
    async Fn_GetDataTemplateEmail() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.loadingDownloadData = true;
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/GetDetailTemplateEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemPolicy.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemPolicy) {
              this.ItemPolicy[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Update(val) {
      this.$router.push({
        path: "/email-template-update",
        query: { id: val.TemplateId },
      });
    },
    Fn_Delete(val) {
      this.DialogDelete = true;
      this.ItemDelete = val;
    },
    fn_checkActionType(val, item) {
      if (val == "Edit") {
        this.Fn_Update(item);
      } else if (val == "Del") {
        this.Fn_Delete(item);
      } else if (val == "Preview") {
        this.$router.push({
          path: "/email-template-detail",
          query: { id: item.TemplateId },
        });
      }
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
